import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(5)};
`

export const columnsWrapper = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing(1.25)};
`

export const labelWrapper = (theme: Theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: ${theme.spacing(1.25)};
`

export const optionsWrapper = (theme: Theme) => css`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .MuiButtonBase-root {
    margin: 0 10px;
  }

  .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }
`

export const buttonsWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.25)};

  margin-top: ${theme.spacing(1.25)};
`
